import { useEffect, useState } from "react";
import { getFormEntriesByFormName } from "../services/formServices";
import toast from "react-hot-toast";
import { FORMNAMES } from "../utilities/codes";
import Banner from "./Banner";

const HomeBanner = () => {
    const [homeBanners, setHomeBanners] = useState([]);

    useEffect(() => {
        getBanners();
    }, [])

    const getBanners = async () => {
        try {
            const response = await getFormEntriesByFormName(FORMNAMES.SCHOOLBANNERS);
            setHomeBanners(response);
        } catch (error) {
            toast.error(error.message);
        }
    }


    return (
        <>
            {homeBanners?.length > 0 &&
                <Banner banners={homeBanners} />
            }
        </>
    );
}

export default HomeBanner
